<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-md-4 col-sm-12">Participants</h4>
                    <div class="col-md-8 col-sm-12 d-flex justify-content-end">
                        <div *ngIf="!pageQuery.isSearch">
                            <button title="Filter" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary position-relative" (click)="filterDialog.show()">
                                <i class="material-icons">filter_alt</i>
                                <span *ngIf="filterDialog.hasFilter" class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                                    <span class="visually-hidden">New alerts</span>
                                </span>
                            </button>
                            <button title="Refresh" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="getData()">
                                <i class="material-icons">refresh</i>
                            </button>
                            <button title="Search" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="pageQuery.isSearch=true">
                                <i class="material-icons">search</i>
                            </button>
                            <button title="Download" [attr.disabled]="loading.status ? 'disabled' : null" class="btn btn-secondary ms-1" (click)="downloadData()">
                                <i class="material-icons">file_download</i>
                            </button>
                        </div>
                        <div *ngIf="pageQuery.isSearch" class="w-100">
                            <div class="input-group has-search">
                                <span class="input-group-text pt-0 pb-0 bg-white border-secondary">
                                    <i class="material-icons">search</i>
                                </span>
                                <input type="search" [appAutoFocus]="true" [(ngModel)]="pageQuery.queryPage.q" (keyup)="pageQuery.searchData($event)" class="form-control border-start-0 ps-1 shadow-none border-secondary bg-light" placeholder="Type & Hit Enter">
                                <button title="Search" class="btn btn-secondary" [attr.disabled]="loading.status ? 'disabled' : null" (click)="pageQuery.changeRoute({q:''});pageQuery.isSearch=false;">
                                    <i class="material-icons">close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="filterDialog.hasFilter" class="d-flex pt-2 align-items-center">
                    <div class="pe-2">
                        <button type="button" title="Clear Filter" (click)="filterDialog.hide()" class="btn btn-sm btn-danger p-0">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                    <div class="d-flex">
                        <span *ngIf="filterDialog.model.last_login_at?.from_date;" class="text-bg-info p-1 rounded text-light me-1">
                            Last Login At: {{filterDialog.model.last_login_at?.from_date}} {{filterDialog.model.last_login_at?.from_time}} to {{filterDialog.model.last_login_at?.to_date}} {{filterDialog.model.last_login_at?.to_time}}
                        </span>
                        <span *ngIf="filterDialog.model.created_at?.from_date;" class="text-bg-info p-1 rounded text-light me-1">
                            Created At: {{filterDialog.model.created_at?.from_date}} {{filterDialog.model.created_at?.from_time}} to {{filterDialog.model.created_at?.to_date}} {{filterDialog.model.created_at?.to_time}}
                        </span>
                    </div>
                </div>
                <div class="row pt-2">
                    <div class="col-12">
                        <div class="text-center h4 p-3" *ngIf="!data?.data?.length">
                            <div *ngIf="loading.status">
                                <div class="spinner-grow" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>
                            <div *ngIf="!loading.status">
                                No data found..
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover" *ngIf="data?.data?.length">
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            #
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='name'" [class.desc]="pageQuery.queryPage.order=='-name'" sortable="name" (sort)="onSort($event)">
                                            Name
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='hospital'" [class.desc]="pageQuery.queryPage.order=='-hospital'" sortable="hospital" (sort)="onSort($event)">
                                            Hospital
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='city.name'" [class.desc]="pageQuery.queryPage.order=='-city.name'" sortable="city.name" (sort)="onSort($event)">
                                            City
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='email'" [class.desc]="pageQuery.queryPage.order=='-email'" sortable="email" (sort)="onSort($event)">
                                            Email
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='phone'" [class.desc]="pageQuery.queryPage.order=='-phone'" sortable="phone" (sort)="onSort($event)">
                                            Phone
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='str_number'" [class.desc]="pageQuery.queryPage.order=='-str_number'" sortable="str_number" (sort)="onSort($event)">
                                            STR Number
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='profession'" [class.desc]="pageQuery.queryPage.order=='-profession'" sortable="profession" (sort)="onSort($event)">
                                            Profession
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='status'" [class.desc]="pageQuery.queryPage.order=='-status'" sortable="status" (sort)="onSort($event)">
                                            Status
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='last_login_at'" [class.desc]="pageQuery.queryPage.order=='-last_login_at'" sortable="last_login_at" (sort)="onSort($event)">
                                            Last login at
                                        </th>
                                        <th [class.asc]="pageQuery.queryPage.order=='created_at'" [class.desc]="pageQuery.queryPage.order=='-created_at'" sortable="created_at" (sort)="onSort($event)">
                                            Created at
                                        </th>
                                        <th class="text-center">
                                            <i class="material-icons">more_vert</i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of data?.data;let i=index;">
                                        <td class="text-center">
                                            {{data.from+i}}
                                        </td>
                                        <td>
                                            {{item.name}}
                                        </td>
                                        <td>
                                            {{item.hospital}}
                                        </td>
                                        <td>
                                            {{item.city?.name}}
                                        </td>
                                        <td>
                                            {{item.email}}
                                        </td>
                                        <td>
                                            {{item.phone}}
                                        </td>
                                        <td>
                                            {{item.str_number || '-'}}
                                        </td>
                                        <td>
                                            {{item.profession || '-'}}
                                        </td>
                                        <td nowrap>
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" [disabled]="loading.status" type="checkbox" id="status_{{i}}" (change)="setStatus(item)" [attr.checked]="item.status==1 ? 'checked' : null">
                                                <label class="form-check-label" for="status_{{i}}">{{item.status?'Active':'Inactive'}}</label>
                                            </div>
                                        </td>
                                        <td nowrap>
                                            {{item.last_login_at | dateFormat:'DD MMM YYYY, HH:mm'}}
                                        </td>
                                        <td nowrap>
                                            {{item.created_at | dateFormat:'DD MMM YYYY, HH:mm'}}
                                        </td>
                                        <td class="text-center" nowrap>
                                            <div class="d-flex nav-item justify-content-center" ngbDropdown display="dynamic" placement="bottom-right" container="body">
                                                <button class="btn btn-sm text-primary border-primary border-1 dropdown-toggle" ngbDropdownToggle>
                                                    Action
                                                </button>
                                                <ul ngbDropdownMenu>
                                                    <!-- <a class="dropdown-item btn-link d-flex align-items-center" [class.disabled]="loading.status" title="Edit" routerLink="detail/{{item.id}}">
                                                        <i class="material-icons fs-5 me-3">list</i>
                                                        Detail
                                                    </a> -->
                                                    <!-- <li>
                                                        <a class="dropdown-item btn-link d-flex align-items-center" [class.disabled]="loading.status" title="Edit" routerLink="edit/{{item.id}}">
                                                            <i class="material-icons fs-5 me-3">edit</i>
                                                            Edit
                                                        </a>
                                                    </li> -->
                                                    <li>
                                                        <button [attr.disabled]="loading.status ? 'disabled' : null" class="dropdown-item btn-link d-flex align-items-center" title="Delete" (click)="deleteDialog.show([item.id])">
                                                            <i class="material-icons fs-5 me-3">delete</i>
                                                            Delete
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="data?.data?.length" class="d-flex justify-content-between row small">
                            <div class="col-md-2 small d-flex flex-nowrap row align-items-center">
                                <div class="col-5 d-flex align-items-center">Limit :</div>
                                <select style="height: 25px;" class="form-select form-select-sm col-6 w-50" [attr.disabled]="loading.status ? 'disabled' : null" [(ngModel)]="pageQuery.queryPage.limit" (change)="pageQuery.changeRoute({limit:pageQuery.queryPage.limit});">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div class="col-md-4 d-flex flex-nowrap align-items-center justify-content-center justify-content-md-end">
                                <div class="text-nowrap">
                                    Total: {{data.total || 0}}
                                </div>
                                <div class="text-nowrap">
                                    <button (click)="pageQuery.changeRoute({page:1});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || data.current_page===1 || !data.prev_page_url ? 'disabled' : null">
                                        <span class="material-icons">first_page</span>
                                    </button>
                                    <button (click)="pageQuery.changeRoute({page:(data.prev_page_url).split('page=')[1]});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || data.current_page===1 || !data.prev_page_url ? 'disabled' : null">
                                        <span class="material-icons">navigate_before</span>
                                    </button>
                                    <span>
                                        {{data.current_page || 1}}/{{data.last_page || '&infintie;'}}
                                    </span>
                                    <button (click)="pageQuery.changeRoute({page:(data.next_page_url).split('page=')[1]});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || !data.next_page_url || pageQuery.queryPage.page===data.last_page ? 'disabled' : null">
                                        <span class="material-icons">navigate_next</span>
                                    </button>
                                    <button (click)="pageQuery.changeRoute({page:data.last_page});" class="btn btn-sm border-0 m-1 p-1" [attr.disabled]="loading.status || !data.next_page_url || pageQuery.queryPage.page===data.last_page || !data.last_page ? 'disabled' : null">
                                        <span class="material-icons">last_page</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #deleteModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Delete</h5>
    </div>
    <div class="modal-body">
        Are you sure want to delete this data?
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <div class="spinner-border text-primary" role="status" *ngIf="deleteDialog.isDeleting && loading.status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="modal.close()" [attr.disabled]="loading.status ? 'disabled' : null">Cancel</button>
            &nbsp;
            <button type="button" class="btn btn-danger" (click)="deleteDialog.submit()" [attr.disabled]="loading.status ? 'disabled' : null">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #filterModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Filter</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label class="fw-bold">Last Login At :</label>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-5">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="date" [(ngModel)]="filterDialog.model.last_login_at.from_date" class="form-control">
                                    </div>
                                    <div class="col-4 ps-0">
                                        <input type="time" [(ngModel)]="filterDialog.model.last_login_at.from_time" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 d-flex justify-content-center align-items-center">To</div>
                            <div class="col-5">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="date" [(ngModel)]="filterDialog.model.last_login_at.to_date" class="form-control">
                                    </div>
                                    <div class="col-4 ps-0">
                                        <input type="time" [(ngModel)]="filterDialog.model.last_login_at.to_time" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label class="fw-bold">Created At :</label>
                    </div>
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-5">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="date" [(ngModel)]="filterDialog.model.created_at.from_date" class="form-control">
                                    </div>
                                    <div class="col-4 ps-0">
                                        <input type="time" [(ngModel)]="filterDialog.model.created_at.from_time" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="col-2 d-flex justify-content-center align-items-center">To</div>
                            <div class="col-5">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="date" [(ngModel)]="filterDialog.model.created_at.to_date" class="form-control">
                                    </div>
                                    <div class="col-4 ps-0">
                                        <input type="time" [(ngModel)]="filterDialog.model.created_at.to_time" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-between">
        <div>
            <div class="spinner-border text-primary" role="status" *ngIf="loading.status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="filterDialog.hide()" [attr.disabled]="loading.status ? 'disabled' : null">
                {{filterDialog.hasFilter?'Clear Filter':'Cancel'}}
            </button>
            &nbsp;
            <button type="button" class="btn btn-secondary" (click)="filterDialog.submit()" [attr.disabled]="loading.status ? 'disabled' : null">Filter</button>
        </div>
    </div>
</ng-template>
<div class="d-none">
    <div class="modal-lg"></div>
</div>
